import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { environment } from '@environments/environment';

import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { AuthorizationService } from '@services/authorization.service';
import { appStateStore } from '@shared/stores/app-state.store';
import { MessageHandlerService } from '@services/admin/message-handler.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  private readonly stateStore = inject(appStateStore);

  private readonly authorizationService = inject(AuthorizationService);
  private readonly messageHandler = inject(MessageHandlerService);
  private readonly messageService: MessageService = inject(MessageService);
  private readonly router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let apiEndpoint = this.stateStore.appState.url() || environment.api_server;
    if (!this.router.url.includes('admin') && !this.router.url.includes('authorization') && !request.url.includes('user/session'))
      apiEndpoint = environment.api_server;

    this.authorizationService.updateRemainingTime();

    if (request.url.includes('assets/i18n'))
      apiEndpoint = environment.baseUrl;

    if (request.url.includes('https://') || request.url.includes('assets'))
      apiEndpoint = '';

    let url = request.url;
    if (apiEndpoint)
      url = `${apiEndpoint}${url}`;

    let headers = request.headers;

    const token = this.stateStore.appState.token();
    if (token) {
      headers = headers.append('Authorization', `Bearer ${token}`);
    }

    request = request.clone({ url, headers });
    return next.handle(request).pipe(
      tap(event => {
          if (event instanceof HttpResponse) {
            const result = event.body.result;
            if (result?.message) {
              this.messageHandler.handle(result.message);
            } else if (result?.resultCode === 200) {
              if (result && result.resultComment && result.resultComment !== 'OK')
                this.messageService.add({
                  severity: 'success',
                  detail: result.resultComment,
                  closable: true,
                });
            } else if (result?.resultCode !== 200) {
              if (result && result.resultComment)
                this.messageService.add({
                  severity: 'warn',
                  detail: result.resultComment,
                  closable: true,
                });
            }
          }
        },
        error => {
          this.messageService.add({ severity: 'error', detail: error?.message, closable: true });
        },
      ));
  }
}
